import React, { useRef } from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Form,
    Input,
    Dimmer,
    Modal,
    Loader,
} from "semantic-ui-react";
import config from "../../../config.js";
import ButtonHandler from "../../ButtonHandler.jsx";
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    ListSubheader,
    TextField,
    InputAdornment,
    ListItemText,
    Checkbox
} from "@mui/material";
const storageBaseUrl = config["storage_base_url"];
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchIcon from "@mui/icons-material/Search";
import ReactTable from "react-table-v6";
const ITEM_HEIGHT = 38;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
var apiTimeout = null

import {
    fetchUseraction,
    fetchTemplates,
    psrCustomReportData,
    getPSRChannelList,
    psrCustomReportPivotData,
    getPsrCustomeReportStatus,
    qpsInputUpload,
    getQpsProcessStatus,
    getQpsProcessFilesList,
    getSmartQPSConsoleFile
} from '../../../actions/users_action';
import moment from "moment";



class WholesaleQPS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templateId: "",
            distributors: [],
            selectedDistributor: [],
            selectedTemplate: '',
            templates: [],
            formatUrl:'',
            modalOpen:false,
            currentFile:{},
            fileUploaded:false,
            qpsFileList:[],
            fileType:'',
            qpsConsoleFile:''
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                console.log(res,'res')
                this.setState({ templates: res.templates, templateId: res.templates[res.templates.length - 1]['_id'] })
                
                this.props.getQpsProcessFilesList(res.templates[res.templates.length - 1]['_id'],{
                    onSuccess:(res)=>{
                        this.setState({qpsFileList:res.overallFiles})
                    },
                    onFailure:()=>{

                    }
                })
            },
            onFailure: () => {
            }
        })

        
    }

    dropDownTemplateOnChange = async(event) => {
        const {
            target: { value },
        } = event;

        this.setState({ selectedTemplate: event.target.value })

        this.state.templates.map(async(d) => {
            if (d.name == event.target.value) {
                if(d.wholesaleQPSFormat && d.wholesaleQPSFormat != undefined){
                    this.setState({formatUrl : d.wholesaleQPSFormat,templateId:d._id})
                }
                await this.props.getQpsProcessFilesList(d._id,{
                    onSuccess:(res)=>{
                        this.setState({qpsFileList:res.overallFiles})
                    },
                    onFailure:()=>{

                    }
                })
                await this.props.getSmartQPSConsoleFile(d._id,{
                    onSuccess:(res)=>{
                        if(res.consoleQPS != ''){
                            this.setState({qpsConsoleFile:res.consoleQPS.fileUrl})
                        }
                        else{
                            this.setState({qpsConsoleFile:''})
                        }
                        
                    },
                    onFailure:()=>{

                    }
                })
            }
        })

    }


    downloadReport = () => {
        if(this.state.formatUrl != ''){
            window.open(storageBaseUrl + this.state.formatUrl);
        }
        else{
            alert("Format Not Available")
        }
        

    }

    downloadConsole = ()=>{
        if(this.state.qpsConsoleFile != ''){
            window.open(storageBaseUrl + this.state.qpsConsoleFile);
        }
        else{
            alert("File Not Available")
        }
    }

    closeuploadoption = () =>{
        this.setState({modalOpen:false})
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0],fileUploaded:true})
    };

    uploadFiles = (fileType) =>{
        this.setState({modalOpen:true,fileType:fileType})
    }

    loadData = () => {
        
        this.props.getQpsProcessStatus(this.state.templateId,{
            onSuccess: (res) => {
                console.log(res.result.fileProcessStatus, 'processStatus')
                if (res.result.fileProcessStatus == 'Completed') {
                    this.setState({ loaderStatus: false,modalOpen:false })
                    clearTimeout(apiTimeout)
                    this.props.getQpsProcessFilesList(this.state.templateId,{
                        onSuccess:(res)=>{
                            this.setState({qpsFileList:res.overallFiles})
                        },
                        onFailure:()=>{
    
                        }
                    })
                }

            },
            onFailure: () => {

            }
        })


        apiTimeout = setTimeout(this.loadData, 3000)
    }

    uploadQPSFormat = () =>{
        this.setState({ loaderStatus: true })
        this.props.qpsInputUpload(this.state.currentFile,this.state.templateId,this.state.fileType,{
            onSuccess:(res)=>{
                if(this.state.fileType == 'consoleFile'){
                    this.setState({loaderStatus:false,modalOpen:false,qpsConsoleFile:res.consoleUrl})
                }
                else{
                    apiTimeout = setTimeout(this.loadData, 3000)
                }
            },
            onFailure:()=>{

            }
        })
    }

    downloadQPSPlanfile = fileUrl =>{
        window.open(storageBaseUrl + fileUrl);
    }


    render() {
        console.log(this.state.qpsFileList,'qpsFileList')

        var templateMonths = []

        if(this.state.templates.length){
            this.state.templates.map((d) => {
                templateMonths.push(d.name)
            })
        }

        var columns = [
            {
                Header: "File Name",
                Cell: (row) => (
                  <div style={{textAlign:'center'}}>
                    {row.original.fileName}
                  </div>
                ),
              },
              {
                Header: "Processed Plan Link",
                Cell: (row) => (
                  <div style={{textAlign:'center'}}>
                    
                      <Icon
                        name="download"
                        onClick={() => this.downloadQPSPlanfile(row.original.fileUrl)}
                        style={{
                          width: 100,
                          align: "center",
                          size: "huge",
                        //   marginLeft: "25%",
                          cursor: "pointer",
                          color: "green",
                        }}
                      />
                  </div>
                ),
              },
              
            
           
        ]
        
         
        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <h1
                            style={{
                                display: "inline-block",
                                color: "#2185d0",
                                marginTop: -5
                            }}
                        >
                            Wholesale QPS Report
                        </h1>
                    </div>
                    <div style={{ marginTop: -5 }}>
                        <Label
                            style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                            size="large"
                            color="blue"
                            onClick={()=>this.uploadFiles('consoleFile')}
                        >
                            <Icon name="upload" />
                            Upload QPS Console File
                        </Label>
                    </div>
                    <div style={{ marginTop: -5 }}>
                        <Label
                            style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                            size="large"
                            color="blue"
                            onClick={()=>this.downloadConsole()}
                        >
                            <Icon name="download" />
                            Download QPS Console File
                        </Label>
                    </div>
                    <div style={{ marginTop: -5 }}>
                        {this.state.selectedTemplate != '' && 
                             <Label
                             style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                             size="large"
                             color="blue"
                             onClick={this.downloadReport}
                         >
                             <Icon name="download" />
                             Download Format
                         </Label>
                        }
                       
                    </div>
                    <div style={{ marginTop: -5 }}>
                    {this.state.selectedTemplate != '' && this.state.qpsConsoleFile != '' &&
                        <Label
                            style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                            size="large"
                            color="blue"
                            onClick={()=>this.uploadFiles('qpsFormat')}
                        >
                            <Icon name="upload" />
                            Upload Format
                        </Label>
    }
                    </div>
                   
                </div>
                <Form>
                    <Grid columns={6}>
                        <Grid.Row>
                            <Grid.Column>
                                <FormControl sx={{ m: 2, width: 200 }}>
                                    <InputLabel id="demo-simple-select">Select Month</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={this.state.selectedTemplate}
                                        onChange={this.dropDownTemplateOnChange}
                                        input={<OutlinedInput label="Select Month" />}
                                        MenuProps={MenuProps}
                                    >
                                        {templateMonths.map((name) => (
                                            <MenuItem key={name} value={name}>
                                                <ListItemText primary={name.split('-')[1]} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
                <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
                        <ReactTable
                            noDataText="We couldn't find anything"
                            filterable={true}
                            defaultPageSize={20}
                            sortable={true}
                            style={{ width: "85vw", marginLeft: 30 }}
                            columns={columns}
                            data={this.state.qpsFileList}
                        />
                    </div>

                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload QPS Format :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadQPSFormat}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>


            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchUseraction,
            fetchTemplates,
            psrCustomReportData,
            getPSRChannelList,
            psrCustomReportPivotData,
            getPsrCustomeReportStatus,
            qpsInputUpload,getQpsProcessStatus,
            getQpsProcessFilesList,
            getSmartQPSConsoleFile
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WholesaleQPS));
